import { ActionTree }                  from 'vuex';
import { RootState }                   from '@/store/store.types';
import { State, XAxisReport }          from '@/views/x-axis-report/report-list/store/x-axis-report-list.state.store';
import { deleteReport, getReportList } from '@/views/x-axis-report/report-list/service/x-axis-report-list.service';
import { handleClientBasicError }      from '@/helpers/helpers';
import { Notification }                from '@/components/notification/notification';
import i18n                            from '@/i18n';

const actions: ActionTree<State, RootState> = {
  async getReportList({ commit }): Promise<void> {
    commit('setDataLoaded', true);

    try {
      const { data }: { data: XAxisReport[] } = await getReportList();
      commit('setReportList', data);
    } catch (e) {
      throw Error(e);
    } finally {
      commit('setDataLoaded', false);
    }
  },
  async deleteXAxisReport({ commit, dispatch, rootState }, reportUuid: string): Promise<void> {
    commit('setDataLoaded', true);

    try {
      await deleteReport(reportUuid);
      Notification.success(
        i18n.t(`${rootState.i18n.GLOBAL_PATH}.success.success`),
        i18n.t('vXAxisReportList.success.reportDeleted'),
      );
      dispatch('getReportList');
    } catch (e) {
      handleClientBasicError(e);
    } finally {
      commit('setDataLoaded', false);
    }
  },
};

export default actions;
